/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { PayPalPsp } from "./PayPalPsp";
import * as t from "io-ts";

// required attributes
const PaypalPspListResponseR = t.interface({
  data: t.readonlyArray(PayPalPsp, "array of PayPalPsp")
});

// optional attributes
const PaypalPspListResponseO = t.partial({});

export const PaypalPspListResponse = t.intersection(
  [PaypalPspListResponseR, PaypalPspListResponseO],
  "PaypalPspListResponse"
);

export type PaypalPspListResponse = t.TypeOf<typeof PaypalPspListResponse>;
